import {storeToRefs} from 'pinia';
import {defineNuxtRouteMiddleware, navigateTo, useAuth} from '#imports';

export default defineNuxtRouteMiddleware(async (to) => {
    const auth = useAuth();
    const {getSelectedIdentity} = storeToRefs(auth);

    const selectedIdentity = getSelectedIdentity.value?.id;

    return await navigateTo('/supplier/documents/' + selectedIdentity);
});
